module.exports = __webpack_public_path__ + "static/media/qrcode.8322d296.png";